module.exports = __webpack_public_path__ + "img/click.cb6f361e.svg";